<!--
/**
* @name: Add.vue
* @description: 添加应用通知页面
* @author: 杨波
* @create: 2020/08/17 14:40:37
* @update: 2020/08/17 14:40:37
*/
-->

<template>
  <y-view :title="isEdit ? '编辑应用通知' : isView ? '查看应用通知' : '新增应用通知'" :loading="isLoading">
    <template v-if="!isView">
      <y-form titleAlign="right" titleWidth="100px" contentWidth="400px">
        <y-form-item title="消息标题:" required>
          <k-input placeholder="请输入消息标题" block clearable v-model="editPara.noticeTitle"></k-input>
        </y-form-item>
        <y-form-item title="销售渠道:" required>
          <k-select :class="css.input_width" placeholder="请选择销售渠道" block clearable v-model="editPara.saleChannelCode">
            <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name" :selected="editPara.saleChannelCode == item.code">{{ item.name }}</k-option>
          </k-select>
        </y-form-item>
        <y-form-item title="发送终端:" required>
          <k-select2
            v-model="editPara.sendTerminals"
            :class="css.inputW"
            :data="terminalList"
            text-field="Name"
            style="width: 300px;"
            layer-width="auto"
            layerMinWidthEqual
            :nearby="true"
            placeholder="请选择发送终端"
          >
          </k-select2>
        </y-form-item>
        <y-form-item title="展示方式:" required>
          <k-select placeholder="请选择展示方式" block clearable v-model="editPara.showType">
            <k-option v-for="item in showTypeList" :key="item.value" :value="item.value" :label="item.label" :selected="editPara.showType == item.value">{{ item.label }}</k-option>
          </k-select>
        </y-form-item>
        <y-form-item title="消息内容:" required align="top">
          <k-input tag="textarea" v-validate="'required'" v-model="editPara.noticeContent" block placeholder="请输入。。。。"></k-input>
        </y-form-item>
        <y-form-item title="状态:" required>
          <div>
            <k-radio v-model="editPara.isEnabled" :value="true">启用</k-radio>
            <k-radio v-model="editPara.isEnabled" :value="false">停用</k-radio>
          </div>
        </y-form-item>
      </y-form>
    </template>
    <template v-else>
      <y-form titleAlign="right" titleWidth="100px" contentWidth="400px">
        <y-form-item title="消息标题:" required>
          <span>{{ editPara.noticeTitle }}</span>
        </y-form-item>
        <y-form-item title="销售渠道:" required>
          <span>{{ editPara.saleChannelCode | filterChannel(this.channelList) }}</span>
        </y-form-item>
        <y-form-item title="发送终端:" required>
          <span>{{ editPara.sendTerminals | filterTerminals(this.terminalList) }}</span>
        </y-form-item>
        <y-form-item title="展示方式:" required>
          <span>{{ editPara.showType | filterShowType(this.showTypeList) }}</span>
        </y-form-item>
        <y-form-item title="消息内容:" required align="top">
          <span>{{ editPara.noticeContent }}</span>
        </y-form-item>
        <y-form-item title="状态:" required>
          <span>{{ editPara.isEnabled ? "启用" : "停用" }}</span>
        </y-form-item>
      </y-form>
    </template>
    <div slot="bottom" v-if="!isView">
      <k-button @click="onReset" v-if="isEdit">重置</k-button>
      <k-button @click="onCancel(true, false)" v-else>取消</k-button>
      <k-button type="primary" @click="onSave" :disabled="saveButtonStatus">保存</k-button>
    </div>
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_DETAIL,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_COMPANY_LIST,
  NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_SAVE,
  NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_UPDATE,
} from "@/assets/modules/apiList";
const initEditPara = () => ({
  noticeTitle: "",
  saleChannelCode: "",
  sendTerminals: "",
  showType: "",
  noticeContent: "",
  isEnabled: null,
});
export default {
  data() {
    return {
      isLoading: false,
      editPara: initEditPara(),
      isSaving: false,
      isView: false,
      isEdit: false,
      channelList: [],
      terminalList: [
        {
          Name: "APP",
          Id: "APP",
        },
        {
          Name: "小程序",
          Id: "SMALL",
        },
      ], //终端列表
      showTypeList: [
        {
          value: "HOME",
          label: "首页弹窗",
        },
        {
          value: "LIST",
          label: "消息列表通知",
        },
      ], //展示方式列表
      originData: {},
    };
  },
  computed: {
    saveButtonStatus() {
      let status = false;
      let para = JSON.parse(JSON.stringify(this.editPara));
      if (!this.isView) {
        let noticeTitle = para.noticeTitle.toString().replace(/\s*/g, "");
        let noticeContent = para.noticeContent.toString().replace(/\s*/g, "");
        if (
          noticeTitle.length < 2 ||
          noticeTitle.length > 20 ||
          noticeContent.length < 2 ||
          noticeContent.length < 2 ||
          !para.saleChannelCode ||
          !para.sendTerminals ||
          !para.showType ||
          (!para.isEnabled && para.isEnabled != false)
        ) {
          status = true;
        }
      }
      return status;
    },
  },
  filters: {
    filterShowType(code, arr) {
      let tmp = [];
      arr.forEach((a) => {
        if (code == a.value) {
          tmp.push(a.label);
        }
      });
      return tmp.join(",");
    },
    filterChannel(code, arr) {
      let tmp = [];
      arr.forEach((a) => {
        if (code == a.id) {
          tmp.push(a.name);
        }
      });
      return tmp.join(",");
    },
    filterCompany(code, arr) {
      let codes = code.split(",");
      let tmp = [];
      arr.forEach((a) => {
        if (codes.indexOf(a.code) != -1) {
          tmp.push(a.name);
        }
      });
      return tmp.join(",");
    },
    filterTerminals(code, arr) {
      let codes = code.split(",");
      let tmp = [];
      arr.forEach((a) => {
        if (codes.indexOf(a.Id) != -1) {
          tmp.push(a.Name);
        }
      });
      return tmp.join(",");
    },
  },

  methods: {
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
    getNoticeDetail(id) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_DETAIL,
        para: { id: id },
      })
        .then((res) => {
          this.originData = JSON.parse(JSON.stringify(res));
          this.editPara = res;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onCancel(isClose, isRefresh) {
      // 关闭弹出标签
      this.$controller.open(
        {
          name: "noticeManagement",
          query: {
            refresh: isRefresh ? new Date() - 0 : 0,
          },
        },
        isClose ? this.$root.$router.currentRoute.name : undefined
      );
    },
    onReset() {
      this.editPara = JSON.parse(JSON.stringify(this.originData));
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      this.isSaving = true;
      this.isLoading = false;
      this.$fetch({
        api: this.isEdit ? NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_UPDATE : NESTLE_MESSAGE_BACK_SERVER_MESSAGE_APPLY_NOTICE_SAVE,
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("操作成功");
          setTimeout(this.onCancel(true, true), 1000);
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
  },
  watch: {},
  created() {
    this.getChannelList();
    const { id, edit, view } = this.$route.query;
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getNoticeDetail(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id, edit, view } = to.query;
    this.editPara = initEditPara();
    if (id) {
      if (edit) {
        this.isEdit = true;
        this.isView = false;
      } else if (view) {
        this.isEdit = false;
        this.isView = true;
      } else {
        this.isEdit = false;
        this.isView = false;
      }
      this.getNoticeDetail(id);
    } else {
      this.isEdit = false;
      this.isView = false;
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.inputW {
  width: 400px !important;
}
</style>
